import { render, staticRenderFns } from "./TreeAddressBook.vue?vue&type=template&id=2eceaf46&scoped=true"
import script from "./TreeAddressBook.vue?vue&type=script&lang=js"
export * from "./TreeAddressBook.vue?vue&type=script&lang=js"
import style0 from "./TreeAddressBook.vue?vue&type=style&index=0&id=2eceaf46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eceaf46",
  null
  
)

export default component.exports